import { Platform } from '../SDK/SDK';
import { IRewardItem } from '../State/reducers/score';
import { ItemIDs, itemUnlockInfo } from './Items';
import { TutorialLevelTriggers, TutorialStuckLevelTriggers } from './Tutorial';

export const preLevelHelperReward: IRewardItem = { id: ItemIDs.HIGHLIGHT, val: 1 };

export const helperEnabled = (levelNumber: number, item: ItemIDs) =>
    levelNumber > itemUnlockInfo.find(x => x.id === item).unlockLevel &&
    !TutorialLevelTriggers.includes(levelNumber) &&
    !TutorialStuckLevelTriggers.includes(levelNumber) &&
    sgPlatform !== Platform.Network;

export const helperTimers = {
    timed: 10,
    normal: 20,
};
